import React, {
  useCallback, useRef, useState,
} from 'react';
import {
  Row, Col, Button,
} from 'reactstrap';

import {
  AudioPlayer, Intl, Select, Checkbox, ConfirmationModal,
  AudioFavouriteModal, UploadFileModal, AudioContainer, SurveyAudios,
  LinkLegal,
} from 'components';
import bg from 'assets/img/step3Bg.png';


export default ( {
  messageDisabled, formDisabled, values, onFormChange, onToggleConfirmTtsModal,
  onToggleSaveFavouriteModal, handleCustomAlert, validateCheck,
} ) => {
  const [messageUploadModalOpened, setMessageUploadModalOpened] = useState( false );
  const [messageFavouriteModalOpened, setMessageFavouriteModalOpened] = useState( false );
  const [confirmMessageChangeModalOpened, setConfirmMessageChangeModalOpened] = useState( false );
  const [confirmIvrModalOpened, setConfirmIvrOpened] = useState( false );
  const onCancelMessageChangeCbRef = useRef( null );

  const toggleMessageModal = useCallback( () => {
    if ( values.messageMediaAudioSrc === 'localFile' ) {
      setMessageUploadModalOpened( ( state ) => !state );
    }
    if ( values.messageMediaAudioSrc === 'favourites' ) {
      setMessageFavouriteModalOpened( ( state ) => !state );
    }
  }, [values] );

  const setMessageFileValues = useCallback( ( fileValues ) => {
    if ( values.messageMediaAudioSrc === 'localFile' || values.messageMediaAudioSrc === 'favourites' ) {
      if ( values.messageType === 'simple_message' ) {
        onFormChange( 'singleFile', fileValues.singleFile );
      } else {
        onFormChange( 'introductionFile', fileValues.introductionFile );
        onFormChange( 'optionsFile', fileValues.optionsFile );
        onFormChange( 'farewellFile', fileValues.farewellFile );
      }
    }
    toggleMessageModal();
  }, [values, toggleMessageModal, onFormChange] );

  const closeConfirmMessageChangeModal = useCallback( () => {
    if ( onCancelMessageChangeCbRef.current ) onCancelMessageChangeCbRef.current();
    setConfirmMessageChangeModalOpened( false );
  }, [] );

  const toggleConfirmIvrModal = useCallback( () => {
    setConfirmIvrOpened( !confirmIvrModalOpened );
  }, [confirmIvrModalOpened] );

  const clearMessageAudios = useCallback( () => {
    if ( values.singleFile ) onFormChange( 'singleFile', null );
    if ( values.introductionFile ) onFormChange( 'introductionFile', null );
    if ( values.optionsFile ) onFormChange( 'optionsFile', null );
    if ( values.farewellFile ) onFormChange( 'farewellFile', null );

    onCancelMessageChangeCbRef.current = null;
    closeConfirmMessageChangeModal();
  }, [values, closeConfirmMessageChangeModal, onFormChange] );

  const openMessageConfirmChangeModal = useCallback( ( cancelCb ) => {
    if ( values.singleFile || values.introductionFile
      || values.optionsFile || values.farewellFile ) {
      setConfirmMessageChangeModalOpened( true );
      onCancelMessageChangeCbRef.current = cancelCb;
    } else {
      onCancelMessageChangeCbRef.current = null;
    }
  }, [values] );

  return (
    <>
      <Row>
        <Col md className="offset-md-1">
          <Checkbox
            field="message"
            label="enableMessage"
            disabled={formDisabled}
            onElementClick={() => handleCustomAlert( true )}
            onChange={( value ) => {
              validateCheck( value );
              if ( !value ) {
                if ( values.messageType ) onFormChange( 'messageType', null );
                if ( values.messageMediaAudioSrc ) onFormChange( 'messageMediaAudioSrc', null );
                if ( values.singleFile ) onFormChange( 'singleFile', null );
                if ( values.introductionFile ) onFormChange( 'introductionFile', null );
                if ( values.optionsFile ) onFormChange( 'optionsFile', null );
                if ( values.farewellFile ) onFormChange( 'farewellFile', null );
              }
            }}
          />
        </Col>
      </Row>

      <Row className="answering mt-2">
        <Col md className="d-flex flex-column justify-content-center">
          <img
            src={bg}
            alt="..."
            className="answering-triangle img-fluid d-none d-md-block w-100"
            style={{ height: 180 }}
          />

          <Row noGutters className="w-100">
            <Col md={10} xs={12} className="m-auto">
              <Select
                field="messageType"
                placeholder="answeringMessageType"
                translateOptions
                isDisabled={messageDisabled}
                showErrors={false}
                options={[
                  { id: 'poll', name: 'survey' },
                  { id: 'simple_message', name: 'simpleMessage' },
                  { id: 'ivr', name: 'advancedInteraction' },
                ]}
                onElementClick={() => handleCustomAlert( true )}
                onChange={( val, prevValue ) => {
                  if ( val === 'ivr' ) {
                    toggleConfirmIvrModal();
                    onFormChange( 'messageType', prevValue );
                  } else {
                    openMessageConfirmChangeModal( () => onFormChange( 'messageType', prevValue ) );
                  }
                }}
              />
              <Select
                field="messageMediaAudioSrc"
                placeholder="answeringAudioSource"
                translateOptions
                isDisabled={messageDisabled}
                showErrors={false}
                options={[
                  { id: 'tts', name: 'tts' },
                  { id: 'favourites', name: 'favourites' },
                  { id: 'localFile', name: 'localFile' },
                ]}
                onElementClick={() => handleCustomAlert( true )}
                onChange={( val, prevValue ) => {
                  if ( val === 'tts' ) {
                    onToggleConfirmTtsModal();
                    onFormChange( 'messageMediaAudioSrc', prevValue );
                  } else {
                    openMessageConfirmChangeModal( () => onFormChange( 'messageMediaAudioSrc', prevValue ) );
                  }
                }}
              />
              <div className="mt-4">
                <Button
                  color="app-default"
                  size="app-sm"
                  block
                  disabled={!values.messageType || !values.messageMediaAudioSrc}
                  onClick={toggleMessageModal}
                >
                  <Intl id="setAudioBtn" />
                </Button>
              </div>
            </Col>
          </Row>
        </Col>

        <Col md className="d-flex flex-column justify-content-center mt-4 mt-md-0">
          {values.messageType === 'simple_message' && values.singleFile
            && (
              <AudioContainer onSaveFavourite={() => onToggleSaveFavouriteModal( 'singleFile' )}>
                <AudioPlayer src={values.singleFile.uri} />
              </AudioContainer>
            )}

          {values.messageType === 'poll'
            && <SurveyAudios values={values} onSaveFavourite={onToggleSaveFavouriteModal} />}
        </Col>
      </Row>

      {
        values.messageMediaAudioSrc === 'localFile' && messageUploadModalOpened
        && (
          <UploadFileModal
            entityId={values.id}
            type="message"
            values={values}
            title={`${values.messageType}_${values.messageMediaAudioSrc}`}
            open={messageUploadModalOpened}
            onClose={toggleMessageModal}
            onSubmit={setMessageFileValues}
          />
        )
      }
      {
        values.messageMediaAudioSrc === 'favourites' && messageFavouriteModalOpened
        && (
          <AudioFavouriteModal
            values={values}
            title={`${values.messageType}_${values.messageMediaAudioSrc}`}
            open={messageFavouriteModalOpened}
            onClose={toggleMessageModal}
            onSubmit={setMessageFileValues}
          />
        )
      }

      {confirmMessageChangeModalOpened
        && (
          <ConfirmationModal
            title="answeringChangeTitle"
            subtitle="answeringChangeSubtitle"
            open={confirmMessageChangeModalOpened}
            onClose={closeConfirmMessageChangeModal}
            onConfirm={() => clearMessageAudios( values )}
          />
        )}

      {confirmIvrModalOpened
        && (
          <ConfirmationModal
            title={(
              <span>
                <Intl id="campaignWizardStep3IvrTitle1" />
                {' '}
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <LinkLegal
                  target="_blank"
                  rel="noopener noreferrer"
                  label="here"
                  href={{
                    es: 'https://massphoning.es/contactar/',
                    en: 'https://massphoning.com/contact/',
                  }}
                />
                {' '}
                <Intl id="campaignWizardStep3IvrTitle2" />
              </span>
            )}
            translateTitle={false}
            open={confirmIvrModalOpened}
            confirmClose
            onConfirm={toggleConfirmIvrModal}
            noCancelBtn
            okLabel="save"
          />
        )}
    </>
  );
};
